import { render, staticRenderFns } from "./DialogImagenes.vue?vue&type=template&id=2904e58a&scoped=true"
import script from "./DialogImagenes.vue?vue&type=script&lang=js"
export * from "./DialogImagenes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2904e58a",
  null
  
)

export default component.exports